<template>
  <div class="page-content-container">
    <div class="page-content-header">
      <div class="section-banner">
        <div class="banner-content">
          <div class="banner-content-left">
            <h1 class="banner-title">极客 · 服务中心</h1>
            <div class="banner-description">
              创造更有价值的内容，用技术赢得收入和声音
            </div>
            <div class="banner-subtitle">
              来这里，和 10000+ 优秀布道师一起，为学员提供优质内容和服务。
            </div>
            <div class="page-btn" @click="handleToApply">
              申请成为布道师 <i class="el-icon-arrow-right"></i>
            </div>
          </div>
          <div class="banner-content-right"></div>
        </div>
      </div>
    </div>
    <div class="page-content-body">
      <div class="section-introduction">
        <div class="container-1000">
          <div class="section-title">什么是极客 · 服务中心</div>
          <div class="introduction-description">
            极客致力于构建以价值为核心的、以 AI
            为核心驱动引擎的、面向未来的数字化人才培养与发展体系。 <br />极客 ·
            服务中心是为广大优秀技术人才提供施展才华的平台。
          </div>
          <div class="mission-container">
            <div class="mission-title">布道师使命</div>
            <div class="mission-list">
              <div class="mission-item">
                <i class="mission-item-icon"></i>
                <div class="mission-item-title">技术布道</div>
                <div class="mission-item-title black">策划&分享高价值内容</div>
                <div class="mission-item-desc">
                  <div class="item-desc flex">
                    <img
                      src="../../assets/images/welcome/mission-1-icon1.svg"
                    />
                    <div>任务驱动式项目策划</div>
                  </div>
                  <div class="item-desc flex">
                    <img
                      src="../../assets/images/welcome/mission-1-icon2.svg"
                    />
                    <div>任务驱动式项目策划</div>
                  </div>
                  <div class="item-desc flex">
                    <img
                      src="../../assets/images/welcome/mission-1-icon3.svg"
                    />
                    <div>任务驱动式项目策划</div>
                  </div>
                </div>
              </div>
              <div class="mission-item">
                <i class="mission-item-icon"></i>
                <div class="mission-item-title">实践领袖</div>
                <div class="mission-item-title black">标准化&解决行业痛点</div>
                <div class="mission-item-desc">
                  <div class="item-desc flex">
                    <img
                      src="../../assets/images/welcome/mission-2-icon1.svg"
                    />
                    <div>打造行业标准技能百科</div>
                  </div>
                  <div class="item-desc flex">
                    <img
                      src="../../assets/images/welcome/mission-2-icon2.svg"
                    />
                    <div>因材施教，层次化落地输出</div>
                  </div>
                  <div class="item-desc flex">
                    <img
                      src="../../assets/images/welcome/mission-2-icon3.svg"
                    />
                    <div>精准直击行业痛点</div>
                  </div>
                </div>
              </div>
              <div class="mission-item">
                <i class="mission-item-icon"></i>
                <div class="mission-item-title">优化体验</div>
                <div class="mission-item-title black">
                  参与产品升级，持续成长
                </div>
                <div class="mission-item-desc">
                  <div class="item-desc flex">
                    <img
                      src="../../assets/images/welcome/mission-3-icon1.svg"
                    />
                    <div>积极参与产品内测&公测</div>
                  </div>
                  <div class="item-desc flex">
                    <img
                      src="../../assets/images/welcome/mission-3-icon2.svg"
                    />
                    <div>为产品体验的提升贡献价值</div>
                  </div>
                  <div class="item-desc flex">
                    <img
                      src="../../assets/images/welcome/mission-3-icon3.svg"
                    />
                    <div>保持学习，与百万同行一起成长</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section-ability">
        <div class="container-1000">
          <div class="section-title" style="margin-bottom:48px">
            在这里，你可以
          </div>
          <div class="ability-list">
            <div class="list-item">
              <div class="item-title">
                构建岗位
              </div>
              <div class="item-description">
                构建岗位技能模型
              </div>
            </div>
            <div class="list-item">
              <div class="item-title">
                创建知识树
              </div>
              <div class="item-description">
                创建技能知识树
              </div>
            </div>
            <div class="list-item">
              <div class="item-title">
                技能出题
              </div>
              <div class="item-description">
                建设技能测评题库
              </div>
            </div>
            <div class="list-item">
              <div class="item-title">
                翻译校对
              </div>
              <div class="item-description">
                翻译校对技能题库
              </div>
            </div>
            <div class="list-item">
              <div class="item-title">
                项目设计
              </div>
              <div class="item-description">
                设计真实场景实战项目
              </div>
            </div>
            <div class="list-item">
              <div class="item-title">
                课程设计
              </div>
              <div class="item-description">设计课程大纲,录制课程</div>
            </div>
            <div class="list-item">
              <div class="item-title">
                学员辅导
              </div>
              <div class="item-description">
                设计1v1辅导学习路径
              </div>
            </div>
            <div class="list-item">
              <div class="item-title">
                作业批改
              </div>
              <div class="item-description">
                批改学生项目作业
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section-benefit">
        <div class="container-1000">
          <div class="section-title" style="margin-bottom: 64px">
            在这里，你能获得
          </div>
          <div class="benefit-list">
            <div class="benefit-item">
              <i class="benefit-item-icon"></i>
              <div class="benefit-item-title">VIP课程</div>
              <div class="benefit-item-desc">3000+课程免费学习</div>
            </div>
            <div class="benefit-item">
              <i class="benefit-item-icon"></i>
              <div class="benefit-item-title">丰厚奖励</div>
              <div class="benefit-item-desc">丰厚的收入</div>
            </div>
            <div class="benefit-item">
              <i class="benefit-item-icon"></i>
              <div class="benefit-item-title">高质人脉</div>
              <div class="benefit-item-desc">高质量的技术交流圈</div>
            </div>
            <div class="benefit-item">
              <i class="benefit-item-icon"></i>
              <div class="benefit-item-title">免费券</div>
              <div class="benefit-item-desc">职业课程免费名额</div>
            </div>
            <div class="benefit-item">
              <i class="benefit-item-icon"></i>
              <div class="benefit-item-title">晋升计划</div>
              <div class="benefit-item-desc">级别越高收入越多</div>
            </div>
            <div class="benefit-item">
              <i class="benefit-item-icon"></i>
              <div class="benefit-item-title">定期沙龙</div>
              <div class="benefit-item-desc">定期线下沙龙</div>
            </div>
          </div>
        </div>
      </div>
      <div class="section-step" id="section-step">
        <div class="container-1000">
          <div class="section-title" style="margin-bottom:48px;">
            入驻流程
          </div>
          <div class="section-step-content">
            <div class="section-step-item">
              <i
                class="el-icon-success step-icon"
                v-if="latestInfo.apply_status > 1"
              ></i>
              <div class="step-number active" v-else>
                1
              </div>
              <div class="step-content">
                <div class="flex">
                  <div class="step-content-title active">
                    {{
                      latestInfo.apply_status == 0
                        ? "提交申请"
                        : latestInfo.apply_status == 1
                        ? "已提交申请"
                        : "申请完成"
                    }}
                  </div>
                  <div class="step-content-line"></div>
                </div>
                <div class="step-content-text">
                  根据表单的要求进行信息填写，整个过程会占用您几分钟，请您保证所填信息真实且有效。
                </div>
              </div>
            </div>
            <div class="section-step-item">
              <i
                class="el-icon-success step-icon"
                v-if="latestInfo.apply_status == 3"
              ></i>
              <div
                :class="[
                  'step-number',
                  latestInfo.apply_status == 1 ? 'active' : ''
                ]"
                v-else
              >
                2
              </div>
              <div class="step-content">
                <div class="flex">
                  <div
                    :class="[
                      'step-content-title',
                      latestInfo.apply_status > 1 ? 'active' : ''
                    ]"
                  >
                    {{
                      latestInfo.apply_status == 0
                        ? "等待审核"
                        : latestInfo.apply_status == 1
                        ? "正在审核"
                        : "审核完成"
                    }}
                  </div>
                  <div class="step-content-line"></div>
                </div>
                <div class="step-content-text">
                  一旦您成功提交了申请，我们这边会有专门工作人员仔细核对甚至是和您沟通，约3个工作日左右发送结果。
                </div>
              </div>
            </div>
            <div class="section-step-item">
              <div class="step-number">3</div>
              <div class="step-content">
                <div class="flex">
                  <div class="step-content-title">开始工作</div>
                  <div class="step-content-line"></div>
                </div>
                <div class="step-content-text">
                  恭喜您，审核通过！您再次登录本页面的时候，就直接进入创作工作台，欢迎您的加入，开始工作咯！👏
                </div>
              </div>
            </div>
          </div>
          <img
            class="step-bg-left"
            src="../../assets/images/welcome/bg-left.png"
            alt=""
          />
          <img
            class="step-bg-right"
            src="../../assets/images/welcome/bg-right.png"
            alt=""
          />
          <div
            class="section-step-main"
            @mouseenter="handleFormEnter"
            @mouseleave="handleFormOut"
            id="section-step-main"
          >
            <el-form
              ref="applyInfo"
              :model="applyInfo"
              label-position="top"
              :hide-required-asterisk="true"
              :rules="applyRules"
              v-if="latestInfo.apply_status == 0"
            >
              <el-row :gutter="24">
                <el-col :span="9">
                  <el-form-item prop="name">
                    <div slot="label" class="flex">
                      <div class="form-item-name">姓名</div>
                      <img
                        src="../../assets/images/welcome/icon-form-redStar.svg"
                      />
                    </div>
                    <el-input
                      class="form-item-input"
                      v-model="applyInfo.name"
                      placeholder="请填写真实姓名"
                    ></el-input> </el-form-item
                ></el-col>
                <el-col :span="15">
                  <el-form-item prop="email">
                    <div slot="label" class="flex">
                      <div class="form-item-name">邮箱</div>
                      <img
                        src="../../assets/images/welcome/icon-form-redStar.svg"
                      />
                    </div>
                    <el-input
                      class="form-item-input"
                      v-model="applyInfo.email"
                      placeholder="请填写常用邮箱"
                    ></el-input> </el-form-item
                ></el-col>
              </el-row>
              <el-form-item prop="iphone">
                <div slot="label" class="flex">
                  <div class="form-item-name">手机号</div>
                  <img
                    src="../../assets/images/welcome/icon-form-redStar.svg"
                  />
                </div>
                <el-input
                  class="form-item-input iphone"
                  v-model="applyInfo.phone"
                  placeholder="请输入手机号"
                >
                  <template slot="prepend">+86</template>
                </el-input>
              </el-form-item>
              <el-row :gutter="24">
                <el-col :span="9">
                  <el-form-item prop="qualification">
                    <div slot="label" class="flex">
                      <div class="form-item-name">学历</div>
                      <img
                        src="../../assets/images/welcome/icon-form-redStar.svg"
                      />
                    </div>
                    <el-select
                      v-model="applyInfo.qualification"
                      clearable
                      class="form-item-select"
                      placeholder="请选择学历"
                    >
                      <el-option
                        v-for="item in constData.educations"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option> </el-select></el-form-item
                ></el-col>
                <el-col :span="15">
                  <el-form-item prop="college">
                    <div slot="label" class="flex">
                      <div class="form-item-name">毕业院校</div>
                      <img
                        src="../../assets/images/welcome/icon-form-redStar.svg"
                      />
                    </div>
                    <el-input
                      class="form-item-input"
                      v-model="applyInfo.college"
                      placeholder="请填写毕业院校"
                    ></el-input> </el-form-item
                ></el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="9">
                  <el-form-item prop="job_year">
                    <div slot="label" class="flex">
                      <div class="form-item-name">工作年限</div>
                      <img
                        src="../../assets/images/welcome/icon-form-redStar.svg"
                      />
                    </div>
                    <el-select
                      class="form-item-select"
                      v-model="applyInfo.job_year"
                      clearable
                      placeholder="请选择工作年限"
                    >
                      <el-option
                        v-for="item in constData.years"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select> </el-form-item
                ></el-col>
                <el-col :span="15">
                  <el-form-item prop="company_name">
                    <div slot="label" class="flex">
                      <div class="form-item-name">公司简称</div>
                      <img
                        src="../../assets/images/welcome/icon-form-redStar.svg"
                      />
                    </div>
                    <el-input
                      class="form-item-input"
                      v-model="applyInfo.company_name"
                      placeholder="请填写公司简称"
                    ></el-input> </el-form-item
                ></el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="9">
                  <el-form-item prop="industry_show">
                    <div slot="label" class="flex">
                      <div class="form-item-name">所在行业</div>
                      <img
                        src="../../assets/images/welcome/icon-form-redStar.svg"
                      />
                    </div>
                    <el-cascader
                      v-model="applyInfo.industry_show"
                      :options="industryList"
                      :props="optionProp_industry"
                      placeholder="请选择行业分类"
                      @change="handleCascaderIndustry"
                      class="form-item-cascader"
                      ref="cascaderIndustry"
                      clearable
                    ></el-cascader> </el-form-item
                ></el-col>
                <el-col :span="15">
                  <el-form-item prop="target_jobs">
                    <div slot="label" class="flex">
                      <div class="form-item-name">岗位方向</div>
                      <img
                        src="../../assets/images/welcome/icon-form-redStar.svg"
                      />
                    </div>
                    <el-cascader
                      v-model="applyInfo.target_jobs"
                      :options="constData.jobs"
                      :props="optionProp_job"
                      @change="handleCascader"
                      collapse-tags
                      ref="cascader"
                      placeholder="请选择行业分类"
                      class="form-item-cascader job"
                      clearable
                    ></el-cascader> </el-form-item
                ></el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="9">
                  <el-form-item prop="position">
                    <div slot="label" class="flex">
                      <div class="form-item-name">工作岗位</div>
                      <img
                        src="../../assets/images/welcome/icon-form-redStar.svg"
                      />
                    </div>
                    <el-select
                      class="form-item-select"
                      v-model="applyInfo.position"
                      clearable
                      placeholder="请选择工作职位"
                    >
                      <el-option
                        v-for="item in constData.positions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select> </el-form-item
                ></el-col>
                <el-col :span="15">
                  <el-form-item prop="prestige">
                    <div slot="label" class="flex">
                      <div class="form-item-name">社会声誉</div>
                      <img
                        src="../../assets/images/welcome/icon-form-redStar.svg"
                      />
                    </div>
                    <el-select
                      class="form-item-cascader"
                      v-model="applyInfo.prestige"
                      clearable
                      placeholder="请选择社会声誉"
                    >
                      <el-option
                        v-for="item in constData.prestige"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select> </el-form-item
                ></el-col>
              </el-row>
              <el-form-item prop="apply_roles">
                <div slot="label" class="flex">
                  <div class="form-item-name">申请角色</div>
                  <img
                    src="../../assets/images/welcome/icon-form-redStar.svg"
                  />
                </div>
                <el-select
                  class="form-item-cascader"
                  v-model="applyInfo.apply_roles"
                  clearable
                  multiple
                  placeholder="请选择申请角色"
                >
                  <el-option
                    v-for="item in constData.roles"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="补充信息">
                <div slot="label" class="flex">
                  <div class="form-item-name">补充信息</div>
                </div>
                <el-input
                  class="form-item-input"
                  type="textarea"
                  placeholder="请输入补充信息"
                  maxlength="6"
                  minlength="4"
                  v-model="applyInfo.direction"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <div slot="label" class="flex-end">
                  <div class="form-item-name">简历</div>
                  <div class="form-item-text">只能上传pdf格式文件</div>
                </div>
                <el-row :gutter="24">
                  <el-col :span="9">
                    <el-upload
                      ref="upload"
                      action=""
                      :limit="1"
                      :before-upload="handleBeforeUpload"
                      :show-file-list="false"
                      accept="application/pdf"
                    >
                      <el-button
                        slot="trigger"
                        :loading="btnLoading"
                        plain
                        class="upload-btn"
                        icon="el-icon-upload2"
                        >选取文件</el-button
                      >
                    </el-upload>
                  </el-col>
                  <el-col :span="15">
                    <div class="upload-file" v-if="file && file.name">
                      <div class="flex">
                        <img
                          class="upload-file-pdf"
                          src="../../assets/images/welcome/icon-pdf.svg"
                        />
                        <el-link
                          class="ellipsis"
                          :underline="false"
                          @click="handlePreview(file.url)"
                          >{{ file.name }}</el-link
                        >
                      </div>

                      <img src="../../assets/images/welcome/icon-yes.svg" />
                    </div>
                  </el-col>
                </el-row>
              </el-form-item>
              <div class="section-step-text">
                来这里，和 10000+ 优秀布道师一起，为学员提供优质内容和服务。
              </div>

              <el-button
                class="section-step-btn"
                type="primary"
                @click="goApply"
              >
                立即申请 <i class="el-icon-arrow-right el-icon--right"></i>
              </el-button>
            </el-form>
            <div
              class="section-step-process"
              v-if="latestInfo.apply_status != 0"
            >
              <div class="step-process-title">最近申请</div>
              <div class="step-process-content">
                <div
                  :class="[
                    'step-process-label',
                    latestInfo.apply_status == 3 ? 'fail' : ''
                  ]"
                >
                  {{ latestInfo.apply_status_label }}
                </div>
                <div class="flex">
                  <div class="process-content-title">申请角色：</div>
                  <div class="process-content-text">
                    {{ latestInfo.apply_roles_label }}
                  </div>
                </div>
                <div class="flex">
                  <div class="process-content-title">申请时间：</div>
                  <div class="process-content-text">
                    {{ latestInfo.created_at }}
                  </div>
                </div>
                <div
                  v-if="[2, 3].includes(latestInfo.apply_status)"
                  class="flex-start"
                >
                  <div class="process-content-title result">审核结果：</div>
                  <div class="process-content-text">
                    {{ latestInfo.handle_result }}
                  </div>
                </div>
              </div>
            </div>
            <div
              class="step-offline-box"
              v-show="formDisable"
              id="step-offline-box"
            >
              <div class="section-step-offline">
                <div class="step-offline-text">您尚未登录，请登录后申请</div>
                <el-button
                  class="step-offline-btn"
                  type="primary"
                  @click="handleLogin"
                >
                  立即登录 <i class="el-icon-arrow-right el-icon--right"></i>
                </el-button>
              </div>
            </div>
          </div>
          <div class="section-step-fail" v-if="latestInfo.apply_status == 3">
            <div class="section-step-text">
              来这里，和 10000+ 优秀布道师一起，为学员提供优质内容和服务。
            </div>
            <el-button
              class="section-step-no"
              type="primary"
              @click="handleAgain"
            >
              重新申请 <i class="el-icon-arrow-right el-icon--right"></i>
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import API from "@/global/request/api";
import qiniuService from "@/global/service/qiniu";
import expertService from "@/global/service/expert";
import kcellService from "@/global/service/kcell";

import Cookie from "js-cookie";
export default {
  computed: {
    ...mapState(["userName"])
  },
  components: {},
  data() {
    return {
      form: {},
      file: [],
      btnLoading: false,
      formDisable: false,
      options: [],
      constData: {},
      applyInfo: {
        name: null,
        email: null,
        phone: null,
        college: null,
        job_year: null, // 工作年限
        qualification: null, // 学历
        company_name: null,
        resume_id: null, // 简历ID
        direction: null,
        industry: null,
        prestige: null,
        apply_roles: [
          // 角色
        ],
        position: null, // 职位
        platform_type: 1,
        jobs: [],
        target_jobs: [],
        industry_show: []
      },
      applyRules: {
        name: { required: true, trigger: "blur", message: "请输入姓名" },
        email: [
          { required: true, trigger: "blur", message: "请输入邮箱" },
          {
            type: "email",
            trigger: ["blur", "change"],
            message: "输入的邮箱不合法"
          }
        ],
        qualification: {
          required: true,
          trigger: "change",
          message: "请选择学历"
        },
        college: {
          required: true,
          trigger: "change",
          message: "请输入毕业学校"
        },
        job_year: {
          required: true,
          trigger: "change",
          message: "请选择工作年限"
        },
        position: { required: true, trigger: "change", message: "请选择岗位" },
        company_name: {
          required: true,
          trigger: "change",
          message: "请输入公司简称"
        },
        target_jobs: {
          required: true,
          message: "请选择岗位方向",
          trigger: "change"
        },
        apply_roles: {
          required: true,
          trigger: "change",
          message: "请选择申请角色"
        },
        industry_show: {
          required: true,
          message: "请选择行业",
          trigger: "change"
        },
        prestige: { required: true, trigger: "blur", message: "请选择社会荣誉" }
      },
      industryList: [],
      optionProp_job: {
        value: "id",
        label: "name",
        children: "children",
        emitPath: false,
        multiple: true
      },
      optionProp_industry: {
        value: "id",
        label: "name",
        children: "children",
        emitPath: false
      },
      latestInfo: {
        apply_status: 0
      },
      TOKEN: null
    };
  },
  created() {
    this.TOKEN = Cookie.get("token");
    if (this.TOKEN) {
      this.getData();
    }
  },
  methods: {
    goApply() {
      this.$refs["applyInfo"].validate(val => {
        if (!val) {
          this.$message.error("必填项不能为空");
          return;
        }
        this.btnLoading = true;
        expertService
          .expertCreate(this.applyInfo)
          .then(() => {
            this.$message.success("您已提交申请，请耐心等待审核");
            this.getData();
          })
          .finally(() => {
            this.btnLoading = false;
          });
      });
    },
    handleBeforeUpload(file) {
      if (!file || !this.validateSize(file)) {
        return false;
      }
      const space = "_for_expert_sub_project";
      const folder = "fuwu";
      const api = API.expertFile;
      this.btnLoading = true;
      qiniuService
        .upload({ space, folder, file, api }, () => {})
        .then(res => {
          this.file = { name: res.name, url: res.url };
          this.applyInfo.resume_id = res.id;
        })
        .finally(() => {
          this.btnLoading = false;
        });
      return false;
    },
    validateSize(file) {
      const fileName = file.name;
      const suffix = fileName.split(".").pop();
      const imageRegex = /(pdf)/;
      if (!imageRegex.test(suffix)) {
        this.$message.error(`请上传格式为pdf的文件`);
        return false;
      }
      return true;
    },
    handleSelectPost(e) {
      this.applyInfo.jobs = e.map(data => {
        return (data = {
          id: data.data.id,
          name: data.data.name,
          short_name: data.data.short_name
        });
      });
    },
    handleBeforeRemove(file) {
      if (file && file.status === "success") {
        this.fileList = [];
        this.applyInfo.resume_id = null;
      }
    },
    handleToApply() {
      const element = document.getElementById("section-step");
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
      // const num = document
      //   .getElementById("section-step")
      //   .getBoundingClientRect().top;
      // window.scrollTo({ top: num - 72, behavior: "smooth" });
    },
    getData() {
      this.loading = true;
      Promise.all([
        expertService.expectLatest(),
        kcellService.kcellIndustryList()
      ])
        .then(res => {
          const latestInfo = res[0]
            ? res[0]
            : {
                apply_status: 0 //0-未申请，1-待审核,2-通过，3-拒绝
              };
          this.industryList = res[1];
          this.getConst(latestInfo);
        })
        .finally(() => {
          this.loading = false;
          this.handleToApply();
        });
    },
    handlePreview(url) {
      if (url) {
        window.open(url);
      }
    },
    getConst(latestInfo) {
      expertService
        .expertConst()
        .then(constData => {
          let result = [];
          if (latestInfo && latestInfo.apply_roles) {
            constData.roles.forEach(role => {
              latestInfo.apply_roles.forEach(id => {
                if (role.value == id) {
                  result.push(role.label);
                }
              });
            });
          }
          this.applyInfo.phone = constData.user.phone;
          this.applyInfo.name = constData.user.name
            ? constData.user.name
            : null;
          latestInfo.apply_roles_name = result.join("、");
          this.latestInfo = latestInfo;
          this.constData = constData;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleCascader(e) {
      let result = [];
      result = this.$refs.cascader.getCheckedNodes(true).filter(data => {
        return e.indexOf(data.value) >= 0;
      });
      this.applyInfo.jobs = result.map(data => {
        return (data = {
          id: data.data.id,
          name: data.data.name,
          short_name: data.data.short_name
        });
      });
    },
    handleCascaderIndustry() {
      const data = this.$refs.cascaderIndustry.getCheckedNodes()[0].data;
      this.applyInfo.industry = {
        id: data.id,
        name: data.name,
        uuid: data.uuid
      };
      // let result = [];
      // result = this.$refs.cascaderIndustry
      //   .getCheckedNodes(true)
      //   .filter(data => {
      //     return e.indexOf(data.value) >= 0;
      //   });
      // this.applyInfo.industry = result.map(data => {
      //   return (data = {
      //     id: data.data.id,
      //     name: data.data.name,
      //     short_name: data.data.short_name
      //   });
      // });
    },
    handleAgain() {
      this.latestInfo.apply_status = 0;
    },
    handleLogin() {
      this.$store.dispatch("login");
    },
    handleFormEnter() {
      if (this.TOKEN) {
        return;
      }
      const ele = document.getElementById("section-step-main");
      const height = ele.offsetHeight;
      const weight = ele.offsetWidth;
      const target = document.getElementById("step-offline-box");
      target.style.height = height + "px";
      target.style.width = weight + "px";
      this.formDisable = true;
    },
    handleFormOut() {
      this.formDisable = false;
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .el-step.is-horizontal .el-step__line {
  top: 26px;
}
/deep/.el-form-item__label {
  line-height: 24px;
}
.flex {
  display: flex;
  align-items: center;
}
.flex-end {
  display: flex;
  align-items: flex-end;
}
.flex-start {
  display: flex;
  align-items: flex-start;
}
/deep/ .el-step__icon {
  width: 50px;
  height: 50px;
}
.page-btn {
  cursor: pointer;
  // width: 210px;
  height: 56px;
  padding: 0 24px;
  background: #409eff;
  box-shadow: 0px 4px 8px 0px rgba(64, 158, 255, 0.2);
  border-radius: 4px;
  line-height: 56px;
  text-align: center;
  font-size: 20px;
  font-weight: 500;
  color: #ffffff;
  &:hover {
    filter: brightness(1.1);
  }
  &.center {
    width: 154px;
    margin: 0 auto;
  }
}
.page-content-container {
  background: #f5f5f5;
  .container-1000 {
    width: 1000px;
    margin: 0 auto;
  }
  .page-content-header {
    background: #fff;
  }
  .section-title {
    height: 45px;
    margin-bottom: 32px;
    font-size: 32px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
    line-height: 45px;
    text-align: center;
  }
  .section-banner {
    height: 396px;
    width: 100%;
    background-image: url("~@/assets/images/welcome/lp-bg.png");
    background-size: 1440px 396px;
    background-position: center;
    background-color: #fff;
    background-repeat: no-repeat;
    .banner-content {
      display: flex;
      justify-content: space-between;
      width: 1180px;
      margin: 0 auto;
      .banner-content-left {
        padding: 72px 0 0;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        width: 600px;
      }
      .banner-content-right {
        width: 480px;
        height: 396px;
        background: url("~@/assets/images/welcome/illustration.png") no-repeat
          center / cover;
        object-fit: contain;
      }
    }
    .banner-title {
      margin-bottom: 10px;
      text-align: center;
      font-weight: 600;
      font-size: 42px;
      color: #141f29;
    }
    .banner-description {
      margin-top: 12px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);
      position: relative;
      z-index: 2;
      display: inline-block !important;
      &::after {
        content: " ";
        width: 100%;
        height: 10px;
        background: #ccedff;
        position: absolute;
        bottom: 4px;
        left: 0;
        border-radius: 4px;
        z-index: -1;
      }
    }
    .banner-subtitle {
      margin: 72px 0 12px;
      font-size: 14px;
      font-weight: 400;
      color: #68718e;
    }
  }
  .page-content-body {
    background: #f5f7fa;
  }
  .section-introduction {
    padding-top: 72px;
    .introduction-description {
      // line-height: 30px;
      text-align: center;
      // font-size: 18px;
      // color: #666;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.65);
      line-height: 32px;
    }
    .mission-container {
      padding-top: 80px;
      .mission-title {
        height: 45px;
        margin-bottom: 48px;
        font-size: 32px;
        font-weight: 600;
        color: #333333;
        line-height: 45px;
        text-align: center;
      }
      .mission-list {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .mission-item {
          width: 318px;
          background-image: url("~@/assets/images/welcome/mission-b.svg");
          height: 272px;
          background-color: #fff;
          padding: 30px 50px;
          .mission-item-icon {
            display: block;
            width: 54px;
            height: 44px;
            background-size: contain;
            background-image: url("~@/assets/images/welcome/mission-1.svg");
            background-repeat: no-repeat;
            background-position: center;
          }
          .mission-item-title {
            font-size: 20px;
            font-weight: 600;
            color: #409eff;
            line-height: 32px;
            &.black {
              color: rgba(0, 0, 0, 0.85);
              margin-bottom: 20px;
              white-space: nowrap;
            }
          }
          .mission-item-desc {
            .item-desc {
              margin-bottom: 8px;
              div {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.85);
                white-space: nowrap;
              }
              img {
                width: 16px;
                height: 16px;
                object-fit: cover;
                margin-right: 8px;
              }
              &:last-child {
                margin-bottom: 0;
              }
            }
          }
          &:nth-child(2) {
            .mission-item-icon {
              background-image: url("~@/assets/images/welcome/mission-2.svg");
            }
          }
          &:nth-child(3) {
            .mission-item-icon {
              background-image: url("~@/assets/images/welcome/mission-3.svg");
            }
          }
        }
      }
    }
  }
  .section-ability {
    padding: 72px 0 34px;
    .ability-list {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      .list-item {
        width: 222px;
        height: 128px;
        padding: 30px;
        margin-bottom: 38px;
        border-radius: 4px;
        background-image: url("~@/assets/images/welcome/ability-1.svg");
        background-size: 222px 128px;
        background-position: center;
        background-repeat: no-repeat;
        &:nth-child(2) {
          background-image: url("~@/assets/images/welcome/ability-2.svg");
        }
        &:nth-child(3) {
          background-image: url("~@/assets/images/welcome/ability-3.svg");
        }
        &:nth-child(4) {
          background-image: url("~@/assets/images/welcome/ability-4.svg");
        }
        &:nth-child(5) {
          background-image: url("~@/assets/images/welcome/ability-5.svg");
        }
        &:nth-child(6) {
          background-image: url("~@/assets/images/welcome/ability-6.svg");
        }
        &:nth-child(7) {
          background-image: url("~@/assets/images/welcome/ability-7.svg");
        }
        &:nth-child(8) {
          background-image: url("~@/assets/images/welcome/ability-8.svg");
        }
        .item-title {
          text-align: center;
          height: 34px;
          line-height: 34px;
          font-size: 26px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #ffffff;
          margin-bottom: 8px;
        }
        .item-description {
          height: 24px;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          line-height: 24px;
          text-align: center;
          white-space: nowrap;
        }
      }
    }
  }
  .section-benefit {
    // background-color: #fff;
    padding-bottom: 72px;
    .benefit-list {
      display: flex;
      justify-content: space-around;
      align-items: center;
      flex-wrap: wrap;
      .benefit-item {
        width: 300px;
        margin-bottom: 80px;
        display: flex;
        flex-direction: column;
        align-items: center;
        &:nth-child(4),
        &:nth-child(5),
        &:nth-child(6) {
          margin-bottom: 0;
        }
        .benefit-item-icon {
          display: block;
          width: 70px;
          height: 70px;
          border-radius: 50%;
          margin-bottom: 16px;
          background-color: #ebeef5;
          background-size: 70px 70px;
          background-image: url("~@/assets/images/welcome/benefit-1.svg");
          background-repeat: no-repeat;
          background-position: center;
        }
        &:nth-child(2) {
          .benefit-item-icon {
            background-image: url("~@/assets/images/welcome/benefit-2.svg");
          }
        }
        &:nth-child(3) {
          .benefit-item-icon {
            background-image: url("~@/assets/images/welcome/benefit-3.svg");
          }
        }
        &:nth-child(4) {
          .benefit-item-icon {
            background-image: url("~@/assets/images/welcome/benefit-4.svg");
          }
        }

        &:nth-child(5) {
          .benefit-item-icon {
            background-image: url("~@/assets/images/welcome/benefit-5.svg");
          }
        }
        &:nth-child(6) {
          .benefit-item-icon {
            background-image: url("~@/assets/images/welcome/benefit-6.svg");
          }
        }
        .benefit-item-title {
          height: 26px;
          margin-bottom: 8px;
          font-size: 18px;
          font-weight: 600;
          color: #333333;
          line-height: 26px;
        }
        .benefit-item-desc {
          height: 22px;
          font-size: 14px;
          font-weight: 400;
          color: #848586;
          line-height: 22px;
        }
      }
    }
  }
  .section-step {
    width: 100%;
    padding: 72px 0;
    background: url("~@/assets/images/welcome/bg-color2.png");
    background-size: 1440px 507px;
    background-position: top;
    background-color: #fff;
    background-repeat: no-repeat;
    position: relative;
    .step-bg-left {
      position: absolute;
      width: 44px;
      height: 54px;
      object-fit: cover;
      left: 18%;
      top: 24%;
    }
    .step-bg-right {
      position: absolute;
      width: 64px;
      height: 48px;
      object-fit: cover;
      top: 30%;
      right: 14%;
    }
    .section-step-content {
      width: 812px;
      margin: 0 auto;
      display: flex;
      .section-step-item {
        display: flex;
        align-items: flex-start;
        margin-right: 12px;
        &:last-child {
          margin-right: 0;
        }
        .step-number {
          width: 32px;
          height: 32px;
          // background: rgba(64, 158, 255, 0.04);
          border: 2px solid rgba(0, 0, 0, 0.45);
          border-radius: 50%;
          text-align: center;
          line-height: 28px;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.45);
          font-size: 14px;
          margin-right: 8px;
          &.active {
            background: #409eff;
            border-color: #409eff;
            color: #fff;
          }
        }
        .step-icon {
          font-size: 32px;
          color: #409eff;
          margin-right: 8px;
        }
        .step-content {
          padding-top: 6px;
          .step-content-title {
            font-size: 16px;
            font-weight: 500;
            color: rgba(0, 0, 0, 0.85);
            &.active {
              color: #409eff;
            }
          }
          .step-content-line {
            width: 148px;
            height: 1px;
            background: rgba(0, 0, 0, 0.15);
            margin-left: 8px;
          }
          .step-content-text {
            width: 228px;
            margin-top: 8px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.45);
          }
        }
      }
    }
    .section-step-main {
      position: relative;
      width: 584px;
      // height: 820px;
      background: #ffffff;
      box-shadow: 0px 0px 0px 6px rgba(64, 158, 255, 0.1);
      border-radius: 2px;
      margin: 45px auto 32px;
      padding: 38px;
      .step-offline-box {
        background: rgba(255, 255, 255, 0.45);
        position: absolute;
        top: 0%;
        left: 0%;
        padding-top: 32px;
        .section-step-offline {
          width: 320px;
          height: 180px;
          margin: 0 auto;
          background: #ffffff;
          box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
            0px 6px 16px 0px rgba(0, 0, 0, 0.08),
            0px 3px 6px -4px rgba(0, 0, 0, 0.12);
          border-radius: 4px;
          padding: 48px 64px;
          text-align: center;
          left: 22%;
          top: 4%;
          .step-offline-text {
            width: 192px;
            height: 24px;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.45);
            line-height: 24px;
            margin-bottom: 12px;
          }
          .step-offline-btn {
            width: 192px;
            height: 48px;
            border-radius: 4px;
            padding: 8px 40px;
            font-size: 20px;
            /deep/.el-icon--right {
              margin-left: 0 !important;
            }
          }
        }
      }

      .section-step-process {
        .step-process-title {
          font-size: 18px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: rgba(0, 0, 0, 0.85);
          margin-bottom: 12px;
        }
        .step-process-content {
          width: 504px;
          background: #ffffff;
          border-radius: 4px;
          border: 1px solid rgba(0, 0, 0, 0.1);
          padding: 32px 40px;
          position: relative;
          .step-process-label {
            position: absolute;
            height: 24px;
            line-height: 24px;
            padding: 0 8px;
            font-size: 12px;
            color: #409eff;
            background: rgba(64, 158, 255, 0.1);
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            border-radius: 2px;
            right: 8px;
            top: 8px;
            &.success {
              color: #67c23a;
              background: #f0f9eb;
            }
            &.fail {
              color: #f56c6c;
              background: #fef0f0;
            }
          }
          & > div {
            margin-bottom: 14px;
            &:last-child {
              margin-bottom: 0;
            }
          }
          .process-content-title {
            font-size: 14px;
            width: 70px;
            font-weight: 500;
            color: rgba(0, 0, 0, 0.85);
            line-height: 22px;
            &.result {
              color: #409eff;
            }
          }
          .process-content-text {
            font-size: 14px;
            font-weight: 400;
            line-height: 22px;
            color: rgba(0, 0, 0, 0.65);
          }
        }
      }
      .form-item-input {
        /deep/.el-input__inner {
          width: 100%;
          height: 38px;
          border-radius: 2px;
        }
      }

      .form-item-check {
        /deep/.el-input__inner {
          width: 100%;
          height: 38px;
          background: #ffffff;
          border-radius: 2px;
          border: 1px solid rgba(0, 0, 0, 0.15);
        }
      }
      .form-item-name {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
        line-height: 24px;
      }
      .form-item-text {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #bfbfbf;
        margin-left: 4px;
        line-height: 20px;
      }
    }
    .section-step-text {
      margin: 10px auto 16px;
      font-size: 14px;
      width: 430px;
      color: #bfbfbf;
    }
    .section-step-no {
      width: 150px;
      height: 48px;
      font-size: 20px;
      /deep/.el-icon--right {
        margin-left: 0 !important;
      }
    }
    .section-step-fail {
      width: 1000px;
      text-align: center;
      margin: 0 auto;
    }

    .section-step-btn {
      width: 504px;
      height: 48px;
      line-height: 48px;
      background: #409eff;
      border-radius: 4px;
      text-align: center;
      padding: 0px 10px;
      cursor: pointer;
      font-size: 20px;
      font-weight: 500;
      color: #fff;
      /deep/.el-icon--right {
        margin-left: 0 !important;
      }
      &:hover {
        filter: brightness(1.1);
      }
    }
  }
}
.upload-btn {
  width: 100%;
  height: 32px;
  border-radius: 2px;
  padding: 4px 42px;
  font-weight: 400;
}
/deep/.el-textarea__inner {
  padding: 10px 15px;
}
.upload-file {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
  background: rgba(0, 0, 0, 0.02);
  border-radius: 2px;
  .upload-file-pdf {
    margin-right: 4px;
  }
  /deep/.el-link--inner {
    width: 200px;
    white-space: nowrap; /* 防止文本换行 */
    overflow: hidden; /* 超出部分隐藏 */
    text-overflow: ellipsis; /* 显示省略号 */
  }
}
.form-item-select {
  width: 100%;
  /deep/.el-input__inner {
    height: 38px !important;
    line-height: 38px;
    border-radius: 2px;
  }
}
.form-item-cascader {
  width: 100%;
  /deep/.el-input__inner {
    min-height: 38px !important;
    line-height: 38px;
    border-radius: 2px;
  }
}
/deep/.el-cascader-menu__wrap {
  height: 180px !important;
}
</style>
